import React, { useEffect, useState } from 'react';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useStyles } from "../styles/styles";
import { getDecimal } from "../global/utils";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ReplayIcon from '@mui/icons-material/Replay';
import PaymentsTwoToneIcon from "@mui/icons-material/PaymentsTwoTone";
import { IconButton, Card } from "@mui/material";
import {DeleteTwoTone} from "@mui/icons-material";

const SelectedFees = (props) => {
    const fees = props.fees;
    const feeTotal = props.feeTotal;
    const processingFee = props.processingFee;
    const splitFees = props.splitFees;
    const removeSelected = props.removeSelected;
    const clearSelected = props.clearSelected;
    const selectedOption = props.selectedOption;
    const onBack = props.onBack;
    const payClicked = props.payClicked;
    const classes = useStyles;
    const [totalAmount, setTotalAmount] = useState(0);
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const cellSx = {...classes.tableCell, fontSize: '.9rem', padding: '.3rem', verticalAlign: 'top'};
    const headCellSx = {...cellSx, color: 'primary.main'};

    useEffect(() => {
        let total = 0;
        if (feeTotal) total += feeTotal;
        if (processingFee) total += processingFee;
        total = parseFloat(getDecimal(total, false));
        setTotalAmount(total);
    }, [feeTotal, processingFee]);

    return (
        <>
            {!smallScreen && (
                <Paper elevation={3} sx={{ ...classes.listContainer, maxHeight: '85vh', overflow: 'auto' }}>
                    <Typography
                        variant='h6'
                        component='h3'
                        color='primary'
                        sx={{ fontSize: '1.2rem', marginTop: 1 }}
                    >
                        Selected Fees
                    </Typography>
                    <TableContainer sx={{ ...classes.list, maxHeight: '100%' }}>
                        <Table size="small" aria-label="Selected fees">
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th" scope="col" sx={headCellSx}>Fee Name</TableCell>
                                    <TableCell component="th" scope="col" align="right" sx={{ ...headCellSx, width: '17%' }}>Item Amt.</TableCell>
                                    <TableCell component="th" scope="col" align="right" sx={{ ...headCellSx, width: '12%' }}>Qty.</TableCell>
                                    <TableCell component="th" scope="col" align="right" sx={{ ...headCellSx, width: '17%' }}>Amount</TableCell>
                                    <TableCell component="th" scope="col" sx={{ ...headCellSx, width: '10%' }}>
                                        <Box component="span" sx={classes.visuallyHidden}>Remove</Box>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fees && fees.map((fee) => (
                                    <TableRow key={fee.key}>
                                        <TableCell component="th" scope="row" sx={cellSx}>
                                            {fee.name}
                                            {fee.comments && (
                                                <Typography variant="body2" color="textSecondary" sx={{ fontSize: '.8rem' }}>
                                                    Comments: {fee.comments}
                                                </Typography>
                                            )}
                                        </TableCell>
                                        <TableCell align="right" sx={cellSx}>{getDecimal(fee.itemAmount)}</TableCell>
                                        <TableCell align="right" sx={cellSx}>{Math.floor(fee.quantity)}</TableCell>
                                        <TableCell align="right" sx={cellSx}>{getDecimal(fee.amount)}</TableCell>
                                        <TableCell align="right" sx={cellSx}>
                                            <Button
                                                variant="contained"
                                                color="error"
                                                onClick={() => removeSelected(fee.key)}
                                                sx={classes.tinyButton}
                                                aria-label={`Delete ${fee.name}`}
                                            >
                                                Delete
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {selectedOption && (
                                    <TableRow>
                                        <TableCell component="th" scope="row" sx={cellSx}>
                                            {selectedOption.name}
                                            <Typography variant="body2" color="textSecondary" sx={{ fontSize: '.8rem' }}>
                                                Description: {selectedOption.description}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right" sx={cellSx} />
                                        <TableCell align="right" sx={cellSx} />
                                        <TableCell align="right" sx={cellSx}>{getDecimal(selectedOption.amount)}</TableCell>
                                        <TableCell align="right" sx={cellSx} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Grid container spacing={1} sx={{ padding: '.5rem 0' }}>
                        <Grid
                            sx={{ ...classes.valueRight, fontWeight: 'medium' }}
                            size={{
                                xs: 10,
                                sm: 4
                            }}>
                            {`Fee Total: ${getDecimal(feeTotal)}`}
                        </Grid>
                        {splitFees ? (
                            <Grid
                                size={{
                                    xs: 11,
                                    md: 6
                                }}>
                                We cannot determine the amount of the Processing Fee until you select a payment type. Depending upon the type of payment you select, you may be required to pay a Processing Fee to process the transaction.
                            </Grid>
                        ) : (
                            <>
                                <Grid
                                    sx={{ ...classes.valueRight, fontWeight: 'medium' }}
                                    size={{
                                        xs: 10,
                                        sm: 4
                                    }}>
                                    {`Processing Fee: ${getDecimal(processingFee)}`}
                                </Grid>
                                <Grid
                                    sx={{ ...classes.valueRight, fontWeight: 'medium' }}
                                    size={{
                                        xs: 10,
                                        sm: 4
                                    }}>
                                    {`Total Amount: ${getDecimal(totalAmount)}`}
                                </Grid>
                            </>
                        )}
                        <Grid size={1}>&nbsp;</Grid>
                    </Grid>
                    <Divider />
                    {/* DOM order is the visual order (2.4.3); justifyContent keeps the
                        row right-aligned, which is what row-reverse used to do. */}
                    <Box
                        component="div"
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            margin: '1rem',
                            gap: '0.5rem',
                        }}
                    >
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<ArrowBackIosNewRoundedIcon />}
                            onClick={onBack}
                            sx={classes.squashedButton}
                        >
                            Back
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<ReplayIcon />}
                            onClick={() => clearSelected()}
                            sx={classes.squashedButton}
                        >
                            Clear
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<PaymentsTwoToneIcon />}
                            onClick={() => payClicked()}
                            sx={classes.squashedButton}
                            aria-haspopup="dialog"
                        >
                            Pay
                        </Button>
                    </Box>
                </Paper>
            )}
            {smallScreen && (
                <>
                    <Typography
                        variant='h6'
                        component='h3'
                        color='primary'
                        sx={{ fontSize: '1.2rem', marginTop: 1}}
                    >
                        Selected Fees
                    </Typography>
                    <List sx={{ padding: 0 }} aria-label="Selected fees">
                    {fees && fees.map((fee) => (
                        <Card component="li" elevation={2} sx={{ margin: '1rem 0', padding: '1rem' }} key={fee.key}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                        {fee.name}
                                    </Typography>
                                    <IconButton
                                        size="small"
                                        onClick={() => removeSelected(fee.key)}
                                        aria-label={`Delete ${fee.name}`}
                                    >
                                        <DeleteTwoTone />
                                    </IconButton>
                                </Box>
                                <Divider />
                                <Grid container spacing={1}>
                                    <Grid size={6}>
                                        <Typography variant="body2" color="textSecondary">Cost:</Typography>
                                    </Grid>
                                    <Grid sx={{ textAlign: 'right' }} size={6}>
                                        <Typography variant="body2">${getDecimal(fee.itemAmount)}</Typography>
                                    </Grid>
                                    <Grid size={6}>
                                        <Typography variant="body2" color="textSecondary">Quantity:</Typography>
                                    </Grid>
                                    <Grid sx={{ textAlign: 'right' }} size={6}>
                                        <Typography variant="body2">{Math.floor(fee.quantity)}</Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid size={6}>
                                        <Typography variant="body2" color="black" sx={{
                                            fontWeight: "bold"
                                        }}>Total:</Typography>
                                    </Grid>
                                    <Grid sx={{ textAlign: 'right' }} size={6}>
                                        <Typography variant="body2" sx={{
                                            fontWeight: "bold"
                                        }}>${getDecimal(fee.amount)}</Typography>
                                    </Grid>
                                </Grid>
                                {fee.comments && (
                                    <>
                                        <Divider />
                                        <Box sx={{ marginTop: '0.5rem' }}>
                                            <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                                                Comments
                                            </Typography>
                                            <Typography variant="body2">{fee.comments}</Typography>
                                        </Box>
                                    </>
                                )}
                            </Box>
                        </Card>
                    ))}
                    {selectedOption && (
                        <Card component="li" elevation={2} sx={{ margin: '1rem 0', padding: '1rem' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                        {selectedOption.name}
                                    </Typography>
                                </Box>
                                <Divider />
                                <Grid container spacing={1}>
                                    <Grid size={6}>
                                        <Typography variant="body2" color="textSecondary">Description:</Typography>
                                    </Grid>
                                    <Grid sx={{ textAlign: 'right' }} size={6}>
                                        <Typography variant="body2">{selectedOption.description}</Typography>
                                    </Grid>
                                    <Grid size={6}>
                                        <Typography variant="body2" color="textSecondary">Amount:</Typography>
                                    </Grid>
                                    <Grid sx={{ textAlign: 'right' }} size={6}>
                                        <Typography variant="body2">${getDecimal(selectedOption.amount)}</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Card>
                    )}
                    </List>
                    <Card elevation={2} sx={{ margin: '1rem 0', padding: '1rem' }}>
                        <Grid container spacing={1}>
                            <Grid size={6}>
                                <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                                    Fee Total:
                                </Typography>
                            </Grid>
                            <Grid sx={{ textAlign: 'right' }} size={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                    ${getDecimal(feeTotal)}
                                </Typography>
                            </Grid>
                            {splitFees ? (
                                <>
                                    <Grid size={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography variant="body2" color="textSecondary">
                                            We cannot determine the amount of the Processing Fee until you select a payment type. Depending upon the type of payment you select, you may be required to pay a Processing Fee to process the transaction.
                                        </Typography>
                                    </Grid>
                                </>
                            ) : (
                                <>
                                    <Grid size={6}>
                                        <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                                            Processing Fee:
                                        </Typography>
                                    </Grid>
                                    <Grid sx={{ textAlign: 'right' }} size={6}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                            ${getDecimal(processingFee)}
                                        </Typography>
                                    </Grid>
                                    <Grid size={6}>
                                        <Typography variant="body2" color="black" sx={{ fontWeight: 'bold' }}>
                                            Total Amount:
                                        </Typography>
                                    </Grid>
                                    <Grid sx={{ textAlign: 'right' }} size={6}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                            ${getDecimal(totalAmount)}
                                        </Typography>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                                marginTop: '1rem',
                            }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={payClicked}
                                aria-haspopup="dialog"
                            >
                                Pay Fees
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={clearSelected}
                            >
                                Clear All Fees
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={onBack}
                            >
                                Back
                            </Button>
                        </Box>
                    </Card>
                </>
            )}
        </>
    );
};

export default SelectedFees;